import moduleConfig from './module-config';
import netsBrowserSupportMsg from './nets-browser-support-msg';

export default angular
  .module('app.browserSupportMsg', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsBrowserSupportMsg', netsBrowserSupportMsg);
